<template>
  <div class="index">
    <FormBox
      ref="FormBox"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      @submit="formSubmit" />
  </div>
</template>

<script>
import FormBox from '@/components/XY/FormBox'
import mixin_form from '@/Mixins/mixin_form'

export default {
  mixins: [mixin_form],
  components: { FormBox },
  data() {
    return {
      sign: 'yiliaofuwu_hjxtpz',

      formItems: [
        {
        //   tType:'xy_text',tHide:true,tChecked:false,tShow:false,tIndex:-1,
        //   fType:'xy_text',fHide:false,fChecked:false,fShow:false,fIndex:-1,
        //   eType:'xy_text',eHide:false,
        //   vType:'xy_input',vHide:false,
        //   label:'地区',key:'fixed-area',
        // }, {
          tType:'xy_text',tHide:false,tChecked:false,tShow:false,tIndex:-1,
          fType:'xy_number',fHide:false,fChecked:false,fShow:false,fIndex:-1,
          eType:'xy_number',eHide:false,
          vType:'xy_input',vHide:false,
          label:'有效通话秒数',key:'validSecond',
        },
      ],
    }
  },
}
</script>

<style lang='scss' scoped>
</style>